import { create } from "zustand";
import { FormInputs, SectionStatus } from "./types";

export const useFormStore = create<{ sectionStatuses: Record<string, SectionStatus> }>(() => ({
  sectionStatuses: {},
}));
